import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'UPD P |||| UPD P records',
      orderM: 'M records',
      fields: {
        id: 'ID',
      },
    }
  }
}